
import KeycloakService from '@/services/keycloak/keycloakService';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Redirect',
    data() {
    },
    mounted() {
        KeycloakService.CallLogin();
    }
});
